import { render, staticRenderFns } from "./ReferralLinkBanner.vue?vue&type=template&id=66925d34&scoped=true"
import script from "./ReferralLinkBanner.vue?vue&type=script&lang=js"
export * from "./ReferralLinkBanner.vue?vue&type=script&lang=js"
import style0 from "./ReferralLinkBanner.vue?vue&type=style&index=0&id=66925d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66925d34",
  null
  
)

export default component.exports